export const Layer = {
    SITE: '中心层面',
    PROJECT: '项目层面'
};

export const LineOfBusiness = ['肿瘤', '非肿瘤', '综合', 'ARO', '招募'];

export const Dimension = {
    GLOBAL: '按全国分析',
    AREA: '按区域分析',
    CITY: '按城市分析',
    COUNTY: '按县级行政区分析',
    HOSPITAL: '按医院分析',
    DEPARTMENT: '按科室分析',
    PROJECT_AREA: '按项目领域分析',
    DISEASE: '按疾病分类分析',
    SICKNESS: '按疾病分析',
    PROJECT: '按项目分类分析',
};

export const DimensionTableColumns = {
    GLOBAL: [{
        title: '业务线',
        key: 'name'
    }],
    AREA: [{
        title: '大区',
        key: 'groupValue'
    }],
    CITY: [{
        title: '大区',
        key: 'areaName'
    }, {
        title: '省份',
        key: 'provinceName'
    }, {
        title: '城市',
        key: 'groupValue'
    }],
    COUNTY: [{
        title: '大区',
        key: 'areaName'
    }, {
        title: '省份',
        key: 'provinceName'
    }, {
        title: '城市',
        key: 'cityName'
    }, {
        title: '县级行政区（如无则默认为上级行政单位）',
        key: 'groupValue'
    }],
    HOSPITAL: [{
        title: '大区',
        key: 'areaName'
    }, {
        title: '省份',
        key: 'provinceName'
    }, {
        title: '城市',
        key: 'cityName'
    }, {
        title: '医院',
        key: 'groupValue',
        width: 120
    }],
    HOSPITAL_COURTYARDAREA: [{
        title: '大区',
        key: 'areaName'
    }, {
        title: '省份',
        key: 'provinceName'
    }, {
        title: '城市',
        key: 'cityName'
    }, {
        title: '县级行政区（如无则默认为上级行政单位）',
        key: 'countyName',
        width: 120
    }, {
        title: '医院',
        key: 'groupValue',
        width: 120
    }, {
        title: '院区',
        key: 'courtyardArea',
        width: 120
    }],
    DEPARTMENT: [{
        title: '大区',
        key: 'areaName'
    }, {
        title: '省份',
        key: 'provinceName'
    }, {
        title: '城市',
        key: 'cityName'
    }, {
        title: '医院',
        key: 'hospitalName',
        width: 120
    }, {
        title: '科室',
        key: 'groupValue'
    }],
    DEPARTMENT_COURTYARDAREA: [{
        title: '大区',
        key: 'areaName'
    }, {
        title: '省份',
        key: 'provinceName'
    }, {
        title: '城市',
        key: 'cityName'
    }, {
        title: '县级行政区（如无则默认为上级行政单位）',
        key: 'countyName',
        width: 120
    }, {
        title: '医院',
        key: 'hospitalName',
        width: 120
    }, {
        title: '院区',
        key: 'courtyardArea',
        width: 120
    }, {
        title: '科室',
        key: 'groupValue'
    }],
    PROJECT_AREA: [{
        title: '业务线',
        key: 'name'
    }, {
        title: '项目领域',
        key: 'groupValue'
    }],
    DISEASE: [{
        title: '业务线',
        key: 'name'
    }, {
        title: '项目领域',
        key: 'investigationAreaName'
    }, {
        title: '疾病分类',
        key: 'groupValue'
    }],
    SICKNESS: [{
        title: '业务线',
        key: 'name'
    }, {
        title: '项目领域',
        key: 'investigationAreaName'
    }, {
        title: '疾病',
        key: 'groupValue'
    }],
    PROJECT: [{
        title: '业务线',
        key: 'name'
    }, {
        title: '项目分类',
        key: 'groupValue'
    }]
}

export const personDimensionTableColumns = {
    GLOBAL: [{
        title: '业务线',
        key: 'name'
    }],
    AREA: [{
        title: '业务线',
        key: 'name'
    }, {
        title: '大区',
        key: 'areaName'
    }],
    CITY: [{
        title: '业务线',
        key: 'name'
    }, {
        title: '大区',
        key: 'areaName'
    }, {
        title: '省份',
        key: 'provinceName'
    }, {
        title: '城市',
        key: 'cityName'
    }],
    PROJECT_AREA: [{
        title: '业务线',
        key: 'name'
    }, {
        title: '项目领域',
        key: 'investigationAreaName'
    }]
}

export const Indicator = [{
    source: 'project',
    moduleType: 'MONTH_GROUP',
    name: '入组情况',
    title: '每月入组情况',
    // tips: "每月25号24点“试验进行中”的患者数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_IN_GROUP',
    name: '在组情况',
    title: '每月在组数',
    // tips: "每月25号24点“试验进行中”的患者数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_CRC_FTE',
    name: 'CRC消耗FTE情况',
    title: '每月CRC消耗FTE',
    // tips: "每月产生的CRC项目确认FTE",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_NEW_SITE',
    name: '中心启动情况',
    title: '每月启动中心数',
    // tips: "每月新启动中心数/每月未关闭中心数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                //HOSPITAL: [{ type: 'table' }],
                //DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_PROJECT_NUM',
    name: '项目数量情况',
    title: '每月项目数量情况',
    // tips: "每月进行中项目数/每月结束项目数/每月所有项目数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    // { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_VISIT_AMOUNT',
    name: '完成访视情况',
    title: '每月完成访视数',
    // tips: "每月完成访视数/每月累计完成访视数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_STANDARD_VISIT_AMOUNT',
    name: '已确认标准访视数情况',
    title: '每月已确认标准访视数',
    // tips: "每月完成标准访视数/每月累计完成标准访视数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "dAmount", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "dAmount", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_UNITS_FTE_GROUP',
    name: '单位FTE入组数',
    title: '每月单位FTE入组数',
    // tips: "每月入组数/每月CRC消耗FTE",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_UNITS_FTE_VISIT',
    name: '单位FTE访视数',
    title: '每月单位FTE访视数',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_UNITS_FTE_STANDARD_VISIT',
    name: '单位FTE标准访视数',
    title: '每月单位FTE标准访视数',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_PER_RANDOM_AMOUNT',
    name: '人均入组数',
    title: '每月人均入组数',
    allBusiness: true,
    // tips: "每月入组数/每月城市人数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                //DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_PER_VISIT_AMOUNT',
    name: '人均访视数',
    title: '每月人均访视数',
    allBusiness: true,
    // tips: "每月访视数/每月城市人数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_PER_STANDARD_VISIT_AMOUNT',
    name: '人均确认标准访视数',
    title: '每月人均确认标准访视数',
    allBusiness: true,
    // tips: "每月人均确认标准访视数/每月城市人数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONITOR_SITE_START_GLOBAL',
    name: '平均启动时长',
    title: '每月平均启动时长',
    // tips: "每月新启动中心数的启动时长平均值",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                //DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'REQUIREMENT_SATISFIED_GLOBAL',
    name: '需求满足率',
    title: '每月需求满足率',
    // tips: "每月满足需求数量/每月需求总量",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'REQUIREMENT_FTE_GLOBAL',
    name: '需求FTE情况',
    title: '每月需求处理的FTE情况',
    // tips: "当月已处理需求的FTE/当月待处理需求的FTE",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_MAJOR_EVENT',
    name: '重大事件发生数',
    title: '每月重大事件发生数',
    // tips: "每月重大事件发生数/累计重大事件数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'MONTH_MAJOR_EVENT_RATE',
    name: '重大事件发生率',
    title: '每月重大事件发生率',
    // tips: "当年重大事件发生率=当年累计重大事件数/当年累计完成访视数",
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'PLAN_RANDOM_AMOUNT',
    name: '计划入组数情况',
    title: '每月计划入组数',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'PLAN_VISIT_AMOUNT',
    name: '计划访视数情况',
    title: '每月计划访视数',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'PLAN_SITE_START',
    name: '计划启动数情况',
    title: '每月计划启动数',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "amount", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'PLAN_FTE',
    name: 'CRC计划FTE情况',
    title: '每月CRC计划FTE',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'project',
    moduleType: 'INV_PLAN_FTE_PROGRESS_DIFF_GRAPH',
    name: '项目计划FTE情况',
    title: '每月项目计划FTE',
    layer: {
        // SITE: {
        //     dimension: {
        //         GLOBAL: [
        //             { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
        //             { type: 'table', icon: '\ue659' }
        //         ],
        //         AREA: [
        //             { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], dataType: "rate", },
        //             { type: 'table', icon: '\ue659' }
        //         ],
        //         CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
        //         HOSPITAL: [{ type: 'table' }],
        //         DEPARTMENT: [{ type: 'table' }],
        //     }
        // },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                SICKNESS: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'],
}, {
    source: 'finance',
    moduleType: 'CnyCurrentMonthIncomeNoTax',
    name: '收入情况',
    title: '每月服务费收入不含税',
    unit: '万元',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], unit: '万元' },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue653', chartTypes: ['column'], unit: '万元', nameProp: 'groupValue', stack: true },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                COUNTY: [{ type: 'table' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合', 'ARO', '招募'],
}, {
    source: 'finance',
    moduleType: 'CurrentMonthInvoice',
    name: '开票收入情况',
    title: '每月开票收入不含税',
    tips: "每月差异不含税=每月预计开票额不含税（请款记录取值）-每月实际开票收入不含税",
    unit: '万元',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue652', chartTypes: ['column', 'line'], unit: '万元' },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue653', chartTypes: ['column'], unit: '万元', nameProp: 'groupValue', stack: true },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合', 'ARO', '招募'],
}, {
    source: 'finance',
    moduleType: 'CnySupplementCurrentMonthIncome',
    name: '补充合同收入',
    title: '每月补充合同收入不含税',
    unit: '万元',
    layer: {
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合', 'ARO', '招募'],
}, {
    source: 'finance',
    moduleType: 'NextMonthOrderInHandNoInvoice',
    name: '在手订单额-非开票项目',
    title: '每月在手订单额(不含税)',
    unit: '万元',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue638', chartTypes: ['line'], unit: '万元' },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue638', chartTypes: ['line'], unit: '万元', nameProp: 'groupValue' },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合', 'ARO', '招募'],
}, {
    source: 'finance',
    moduleType: 'NextMonthOrderInHandInvoice',
    name: '在手订单额-开票项目',
    title: '每月在手订单额(不含税)',
    unit: '万元',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue638', chartTypes: ['line'], unit: '万元' },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue638', chartTypes: ['line'], unit: '万元', nameProp: 'groupValue' },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合', 'ARO', '招募'],
}, {
    source: 'finance',
    moduleType: 'NextMonthOrderInHandExpectedInvoice',
    name: '预计开票额-开票收入项目',
    title: '每月预计开票额(不含税)-开票收入项目',
    unit: '万元',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue638', chartTypes: ['line'], unit: '万元' },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue638', chartTypes: ['line'], unit: '万元', nameProp: 'groupValue' },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合', 'ARO', '招募'],
}, {
    source: 'finance',
    moduleType: 'MonthNewContractNum',
    name: '新增合同',
    title: '每月新增合同',
    layer: {
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合', 'ARO', '招募'],
}, {
    source: 'finance',
    moduleType: 'MonthWorkInAdvanceNum',
    name: '提前上岗合同',
    title: '每月提前上岗合同',
    layer: {
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合', 'ARO', '招募'],
}, {
    source: 'finance',
    moduleType: 'MonthInvoiceFinishDeviationAmount',
    name: '截止当月累计开票进度和完工进度金额差异',
    title: '截止当月累计开票进度和完工进度金额差异（不含税）',
    tips: "注：每月差异=截止当月完工进度金额（不含税）-截止当月已开票金额（不含税）",
    layer: {
        PROJECT: {
            dimension: {
                PROJECT_AREA: [{ type: 'table' }],
                DISEASE: [{ type: 'table' }],
                PROJECT: [{ type: 'table' }],
            }
        }
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合', 'ARO', '招募'],
}, {
    source: 'finance',
    moduleType: 'CnyCurrentMonthIncomeNoTaxByPerson',
    name: '人均收入',
    title: '每月人均收入不含税',
    layer: {
        SITE: {
            dimension: {
                GLOBAL: [
                    { type: 'chart', icon: '\ue638', chartTypes: ['line'], unit: '元' },
                    { type: 'table', icon: '\ue659' }
                ],
                AREA: [
                    { type: 'chart', icon: '\ue638', chartTypes: ['line'], unit: '元', nameProp: 'groupValue' },
                    { type: 'table', icon: '\ue659' }
                ],
                CITY: [{ type: 'map', icon: '\ue8ad' }, { type: 'table', icon: '\ue659' }],
                HOSPITAL: [{ type: 'table' }],
                DEPARTMENT: [{ type: 'table' }],
            }
        },
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'], //, 'ARO', '招募'
},{
    source: 'person',
    moduleType: 'VisitEfficiency',
    name: '访视效率',
    title: '访视效率',
    dimension: {
        GLOBAL: [{ type: 'table' }],
        AREA: [{ type: 'table' }],
        CITY: [{ type: 'table' }],
        PROJECT_AREA: [{ type: 'table' }],
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'], //, 'ARO', '招募'
},{
    source: 'person',
    moduleType: 'EmpOutPutRate',
    name: '人员产出率',
    title: '人员产出率',
    allBusiness: true,
    dimension: {
        GLOBAL: [{ type: 'table' }],
        AREA: [{ type: 'table' }],
        CITY: [{ type: 'table' }],
        PROJECT_AREA: [{ type: 'table' }],
    },
    business: ['所有项目', '肿瘤', '非肿瘤', '综合'], //, 'ARO', '招募'
}];

export const DefaultParams = {
    project:{
        scale: {
            statisticalRange: 'SITE',
            lineOfBusiness: -1,
            analysisDimension: 'GLOBAL',
        }, 
        efficiency: {
            statisticalRange: 'SITE',
            lineOfBusiness: -1,
            analysisDimension: 'GLOBAL',
        }, 
        operationMonitor: {
            statisticalRange: 'SITE',
            lineOfBusiness: -1,
            analysisDimension: 'GLOBAL',
        }, 
        scheduleVariance: {
            statisticalRange: 'SITE',
            lineOfBusiness: -1,
            analysisDimension: 'GLOBAL',
        }, 
    },
    finance: {
        financeIncome: {
            statisticalRange: 'PROJECT',
            lineOfBusiness: -1,
            analysisDimension: 'PROJECT_AREA',
        },
        centerIncome: {
            statisticalRange: 'SITE',
            lineOfBusiness: -1,
            analysisDimension: 'GLOBAL',
        },
        request: {
            statisticalRange: 'PROJECT',
            lineOfBusiness: -1,
            analysisDimension: 'PROJECT_AREA',
        }
    },
    person: {
        financeIncome: {
            statisticalRange: 'PROJECT',
            lineOfBusiness: -1,
            analysisDimension: 'GLOBAL',
        },
    }
};



// WEBPACK FOOTER //
// ./src/components/homePage/constants/dimension.js